import * as React from 'react';
import { translation } from 'easit--localization';
import { observer } from 'mobx-react';

export interface ICashOutListProps {
    items: React.ReactNode;
}

export const CashOutList: React.FC<ICashOutListProps> = observer((props: ICashOutListProps) => {
    return <table className="cashout-list">
        <thead>
            <tr>
                <th className="time-col">{translation().cashoutList_ColumnTime}</th>
                <th>{translation().cashoutList_ColumnStake}</th>
                <th>{translation().cashoutList_ColumnPotentialPrice}</th>
                <th>{translation().cashoutList_ColumnSell}</th>
            </tr>
        </thead>
        <tbody>
            {
                props.items
            }
        </tbody>
    </table>
});